import { render, staticRenderFns } from "./Keperluan.vue?vue&type=template&id=e2b7026e&"
import script from "./Keperluan.vue?vue&type=script&lang=js&"
export * from "./Keperluan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports